import { evaluateConfig, getCookies, setCookie, deleteCookie } from "@crystal/core";
import { PARTNER_COOKIE_CODE, PARTNER_COOKIE_STATE, PARTNER_TOKEN_COOKIE_NAME, PARTNER_COOKIE_NAME, AUTH_INFO_COOKIE_NAME } from "../cookie.js";
import { getHostInfo } from "../store/state/getters.js";
import "../store/state/host.js";
import "../store/state/modal.js";
import "../store/storage/memory-storage.js";
import "mitt";
import "../store/storage/universal-memory-storage.js";
import "@reduxjs/toolkit";
import "../api/email-detection.js";
import "@account/configs";
import "@crystal/glass-bridge";
import "@crystal/http";
import "@crystal/recaptcha";
import "@crystal/analytics";
import "react";
import "../state/reducers.js";
import "../state/actions.js";
import "../state/utils.js";
import { config } from "./config.js";
import "./state.js";
import "../external-auth/config.js";
import "@crystal/config";
import "../config/source-ids.js";
import "../config/presets.js";
import { GenericError } from "../api/user-types.js";
const getBasicUser = async () => {
  const [, country] = getHostInfo().context.locale.split("_");
  const clientId = evaluateConfig(config.prop("clientId"));
  let error;
  try {
    const response = await fetch(`/auth/session`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Application-Country": country,
        "X-Client-Id": clientId
      }
    });
    if (response.ok) {
      const user = await response.json();
      setLegacySessionCookie(user);
      return user;
    }
    await revokeAuthToken();
    error = new GenericError("Invalid session", {
      details: {}
    });
  } catch (err) {
    error = new GenericError("Unknown error", {
      details: err
    });
  }
  return Promise.reject(error.serialize());
};
const revokeAuthToken = async () => {
  const [, country] = getHostInfo().context.locale.split("_");
  const clientId = evaluateConfig(config.prop("clientId"));
  try {
    return await fetch(`/auth/session`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "Application-Country": country,
        "X-Client-Id": clientId
      }
    }).finally(() => deleteLegacySessionCookie());
  } catch (err) {
    const error = new GenericError(err, {
      details: err
    });
    return Promise.reject(error.serialize());
  }
};
const linkNaver = async () => {
  const context = getHostInfo().context;
  const locale = context.locale;
  const xApiKey = config.prop("serviceLayerApiKey").evaluateWithContext(context);
  const env = context.env;
  const code = getCookies()[PARTNER_COOKIE_CODE];
  const state = getCookies()[PARTNER_COOKIE_STATE];
  const sourceId = {
    local: 6000001168,
    dev: 6000001168,
    stg: 6000001168,
    prod: 6000001949
  };
  try {
    return await fetch(`/acq-api/account/partners/naver/link?sourceId=${sourceId[env]}&locale=${locale}`, {
      method: "POST",
      body: JSON.stringify({
        code,
        state
      }),
      headers: {
        "Content-Type": "application/json",
        brand: "adidas",
        "x-api-key": xApiKey
      }
    });
  } catch (err) {
    const error = new GenericError(err, {
      details: err
    });
    return Promise.reject(error.serialize());
  }
};
const linkPartner = async () => {
  const context = getHostInfo().context;
  const locale = context.locale;
  const [, country] = locale.split("_");
  const xApiKey = config.prop("serviceLayerApiKey").evaluateWithContext(context);
  const linkingToken = getCookies()[PARTNER_TOKEN_COOKIE_NAME];
  const linkingPartner = getCookies()[PARTNER_COOKIE_NAME];
  const authTokenOrigin = "web-cookie";
  const accessTokenName = "account.grant.accessToken";
  try {
    return await fetch(
      `/acq-api/account/partners/link?origin=${authTokenOrigin}&token=${accessTokenName}&locale=${locale}`,
      {
        method: "POST",
        body: JSON.stringify({
          country,
          partnerId: linkingPartner,
          token: linkingToken
        }),
        headers: {
          "Content-Type": "application/json",
          brand: "adidas",
          "x-api-key": xApiKey
        }
      }
    ).finally(() => deletePartnerCookies());
  } catch (err) {
    const error = new GenericError(err, {
      details: err
    });
    return Promise.reject(error.serialize());
  }
};
function setLegacySessionCookie(user) {
  const { session } = user;
  const cookie = {
    isLoggedin: true,
    isPersistent: !!session.isPersistent
  };
  setCookie(AUTH_INFO_COOKIE_NAME, encodeURIComponent(JSON.stringify(cookie)));
}
function deleteLegacySessionCookie() {
  deleteCookie(AUTH_INFO_COOKIE_NAME);
}
function deletePartnerCookies() {
  deleteCookie(PARTNER_TOKEN_COOKIE_NAME);
  deleteCookie(PARTNER_COOKIE_NAME);
  deleteCookie(PARTNER_COOKIE_CODE);
  deleteCookie(PARTNER_COOKIE_STATE);
}
export {
  deletePartnerCookies,
  getBasicUser,
  linkNaver,
  linkPartner,
  revokeAuthToken
};
//# sourceMappingURL=api-authn.js.map
